import { useNavigation, useRoute } from "@react-navigation/native";
import {
  Button,
  Page,
  PartialPage,
  Text,
  VStack,
  View,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { keys } from "../../../../utilities/i18n";
import { useImagesSentSuccessProvider } from "../../components/ImagesSentSuccessProvider/hooks";
import { NavigationProp } from "@react-navigation/native";

export interface ImagesSentSuccessPartialScreenProps {}

export function ImagesSentSuccessPartialScreen(
  props: ImagesSentSuccessPartialScreenProps
) {
  const {
    params: { sku },
  } = useRoute<any>();

  const { colors, spacings } = useThemeProvider();
  const navigation = useNavigation<NavigationProp<any>>();
  const { t } = useTranslation();

  const { handlers } = useImagesSentSuccessProvider();

  const footer = (
    <VStack spacing={spacings.s2}>
      <Button
        style={{
          display: "flex",
        }}
        label={t(keys.takePhoto)}
        onPress={() => {
          return handlers.onTakeMore(navigation);
        }}
        color={colors.textOnPrimary}
        backgroundColor={colors.primary}
      />
      <Button
        style={{
          display: "flex",
        }}
        label={t(keys.newProduct)}
        onPress={() => {
          return handlers.onNewProduct(navigation);
        }}
        color={colors.textOnPrimary}
        backgroundColor={colors.primary}
      />
      <Button
        style={{
          display: "flex",
        }}
        label={t(keys.finished)}
        onPress={() => {
          return handlers.onFinished(navigation);
        }}
        color={colors.textOnPrimary}
        backgroundColor={colors.primary}
      />
    </VStack>
  );

  return (
    <PartialPage
      scrollable={false}
      size="compact"
      onClose={() => navigation.goBack()}
      contentContainerStyle={{ flex: 1 }}
    >
      <Page
        footerStyles={{ padding: 0, borderTopWidth: 0 }}
        scrollable
        cover
        footer={footer}
      >
        <View
          style={{
            display: "flex",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Text
            variant="heading"
            fontWeight="medium"
            numberOfLines={5}
            ellipsizeMode="head"
          >
            {t(keys.imagesSentSuccessfully, { sku: sku })}
          </Text>
        </View>
      </Page>
    </PartialPage>
  );
}
